<div class="container" *transloco="let t">
  <div class="row my-4">
    <div class="col-12 col-lg-8 mb-4">
      <h1 class="my-4">POLITIQUE DE CONFIDENTIALITÉ</h1>
      <p>
        Dernière mise à jour : 7 août 2025<br/>
        Voir aussi nos <a [routerLink]="routes.terms">Conditions Générales d’Utilisation</a>
      </p>

      <section>
        <h3>1. Présentation</h3>
        <p>
          La présente politique explique comment l'Association P.H.A.R.E. (ci-après "l’Association") traite les données personnelles dans le cadre de l’utilisation de l’application {{ appName }}, accessible au domaine internet {{ domain }} (ci-après "l’Application").
        </p>
        <p>
          Cette politique est conforme à la Nouvelle Loi fédérale sur la protection des données (nLPD) en vigueur en Suisse.
        </p>
      </section>

      <section>
        <h3>2. Collecte des données</h3>

        <h4>Utilisateurs publics, non connectés (consultation)</h4>
        <ul>
          <li>Aucune donnée personnelle n’est collectée lors de la simple consultation des activités.</li>
          <li>L’Application peut enregistrer des statistiques anonymes (par ex. nombre de recherches ou clics) pour améliorer le service.</li>
        </ul>
        <h4>Création de compte</h4>
        <p>
          Lors de la création d’un compte, nous collectons les informations fournies volontairement par l’utilisateur, telles que :
        </p>
        <ul>
          <li>Adresse email</li>
          <li>Nom et prénom</li>
          <li>La civilité</li>
        </ul>

        <h4>Publication d'une activité</h4>
        <p>
          Lors de la publication d'une activité (ci après l'Activité), nous collectons des informations en lien avec l'Activité proposée, telles que :
        </p>
        <ul>
          <li>Des informations sur l'organisateur (ci-après l'Organisation) de l'Activité: raison sociale, nom, etc.</li>
          <li>Le(s) rôle(s) de l'utilisateur dans l'Organisation</li>
          <li>Des informations sur le lieu et les horaires de l'Activité</li>
          <li>Des informations sur l'audience cible de l'Activité: âge, niveau, genre, etc.</li>
          <li>Des informations sur l'Activité : type d'activité(s) proposée(s), prix, liens internet, etc.</li>
          <li>Des informations permettant la mise en avant de l'Activité: titre, description, liens internets, prise de contact, image(s) et document(s) multimédia(s) etc.</li>
        </ul>
      </section>

      <section>
        <h3>3. Base légale du traitement</h3>
        <p>Le traitement des données repose sur :</p>
        <ul>
          <li>L’exécution d’un contrat (utilisation de l’Application et gestion du compte)</li>
          <li>Le consentement de l’utilisateur lors de la soumission de ses données</li>
          <li>L’intérêt légitime de l’Association à assurer le bon fonctionnement et la sécurité de l’Application</li>
        </ul>
      </section>

      <section>
        <h3>4. Stockage et sécurité</h3>
        <ul>
          <li>Toutes les données sont hébergées exclusivement en Suisse.</li>
          <li>L’Association met en place des mesures techniques et organisationnelles raisonnables pour protéger les données contre tout accès non autorisé, perte ou utilisation abusive.</li>
        </ul>
      </section>

      <section>
        <h3>5. Partage des données</h3>
        <ul>
          <li>Les données personnelles ne sont pas vendues, louées ou transmises à des tiers, sauf obligation légale.</li>
          <li>Les informations de contact fournies dans le cadre d’une activité publiée peuvent être visibles publiquement si l’utilisateur choisit de les inclure dans son annonce.</li>
          <li>
            certaines données de l'Activité comme le titre et la description de la publication
            peuvent être transmises à un service de traduction tiers afin
            d'améliorer l'affichage de l'Activité dans d'autres langues.
          </li>
        </ul>

      </section>

      <section>
        <h3>6. Durée de conservation</h3>

        <ul>
          <li>Les données du compte sont conservées tant que celui-ci est actif.</li>
          <li>Les données des publications sont conservées pendant leur mise en ligne, puis supprimées ou archivées selon les besoins légaux.</li>
          <li>Les statistiques anonymes peuvent être conservées sans limitation de durée.</li>
        </ul>
      </section>

      <section>
        <h3>7. Droits des utilisateurs</h3>
        <p>
          Conformément à la nLPD, chaque utilisateur dispose des droits suivants :
        </p>
        <ul>
          <li>Accéder à ses données</li>
          <li>Rectifier ses données</li>
          <li>Demander la suppression de ses données</li>
          <li>S’opposer au traitement de ses données (dans certaines conditions)</li>
        </ul>
        <p>
          Pour exercer ces droits, l’utilisateur peut contacter l’Association par email à {{ contactEmail }}.
        </p>
      </section>

      <section>
        <h3>8. Modifications de la politique</h3>
        <p>
          L’Association peut modifier la présente politique à tout moment.
        </p>
        <p>
          La version en vigueur est celle publiée sur l’Application à la date de consultation.
        </p>
      </section>

      <section>
        <h3>9. Contact</h3>
        <p>
          Pour toute question relative à la protection des données, merci de contacter :
        </p>
        <p class="my-2">
          Email: {{ contactEmail }}
        </p>
        <p>
          Courrier:<br/>
          Association P.H.A.R.E.<br/>
          c/o Vincent Pazeller<br/>
          Rue des Courtils 16<br/>
          2035 Corcelles
        </p>

      </section>
    </div>
  </div>
</div>
